import { Component, Input, OnInit } from '@angular/core';
// @ts-ignore
import counterUp from 'counterup2';


@Component({
  selector: 'app-counterup',
  templateUrl: './counterup.component.html',
  styleUrls: ['./counterup.component.css']
})
export class CounterupComponent implements OnInit {

  @Input() counterUp_params: any = {}



  constructor() { }

  ngOnInit(): void {

    // CounterUp
    const callback = (entries: any[]) => {
      entries.forEach(entry => {
        const el = entry.target
        if (entry.isIntersecting && !el.classList.contains('is-visible')) {
          counterUp(el, {
            duration: 2000,
            delay: 10,
          });
          el.classList.add('is-visible')
        }
      })
    }

    const IO = new IntersectionObserver(callback, { threshold: 1 });

    const elements = document.querySelectorAll('.counter');

    elements.forEach(function (el) {
      IO.observe(el);
    });
    // End CounterUp
  }

}
